<template>
      <div class="manage-left">
          <ul class="manage-menu">
              <li class="menu-item">
                  <a href="javascript:void(0)"><i class="iconfont icon-yudingdan"></i>订单管理</a>
                  <ul class="manage-sub-menu">
                      <li :class="$route.path=='/orderList'?'active sub-menu-item':'sub-menu-item'" @click="$router.push('/orderList')">酒店订单</li>
                  </ul>
              </li>
              <li class="menu-item" v-if="(userInfo.Power&4)==4">
                  <a href="javascript:void(0)"><i class="iconfont icon-baobiao"></i>报表统计</a>
                  <ul class="manage-sub-menu">
                      <li :class="$route.path=='/reportList'?'active sub-menu-item':'sub-menu-item'" @click="$router.push('/reportList')">交易报表</li>
                      <li :class="$route.path=='/reportDay'?'active sub-menu-item':'sub-menu-item'" @click="$router.push('/reportDay')">日看板</li>
                      <li :class="$route.path=='/reportMonth'?'active sub-menu-item':'sub-menu-item'" @click="$router.push('/reportMonth')">月看板</li>
                  </ul>
              </li>
             
              <li class="menu-item" v-if="(userInfo.Power&8)==8">
                  <a href="javascript:void(0)"><i class="iconfont icon-fapiaoguanli" style="font-size: 18px;"></i>发票管理</a>

                  <ul class="manage-sub-menu">
                      <li :class="$route.path=='/invoice'?'active sub-menu-item':'sub-menu-item'" @click="$router.push('/invoice')">申请发票</li>
                      <li  v-if="(userInfo.Power&16)==16" :class="$route.path=='/hotel'?'active sub-menu-item':'sub-menu-item'" @click="$router.push('/hotel')">发票列表</li>
                  </ul>
              </li>
              <li class="menu-item">
                  <a href="javascript:void(0)"><i class="iconfont icon-zhanghuguanli"></i>账户管理</a>
                  <ul class="manage-sub-menu">
                      <li :class="$route.path=='/baseInfo'?'active sub-menu-item':'sub-menu-item'" @click="$router.push('/baseInfo')">基础信息</li>
                      <li :class="$route.path=='/resetPassword'?'active sub-menu-item':'sub-menu-item'" @click="$router.push('/resetPassword')">修改密码</li>
                      
                  </ul>
              </li>
              
          </ul>
      </div>
</template>

<script>
    export default {
        name: "Menu",
        data: function () {
            return {
                userInfo: this.dao.get('userInfo')
            }
        },
        mounted() {
        },
        methods: {}
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/common/cmpnt/menu/Menu.vue